<div class="screen-overlay" *ngIf="isCaseSaving" tabindex="-1" aria-hidden="true">
  <div class="overlay-card">
    <mat-spinner diameter="48" strokeWidth="4"></mat-spinner>
    <div class="overlay-text">Saving… please wait</div>
  </div>
</div>
<div class="custom-header-container">
  <h2 class="custom-fixed-header">Document Details</h2>
</div>
<div class="px-6 py-8">
  <form [formGroup]="searchForm" class="grid grid-cols-4 gap-4 bg-fieldset mb-4 px-4 py-2 rounded"
    (ngSubmit)="getSupremCourtDocType()" *ngIf="isSupremeCourtFlg || isCOAFlg">

    <!-- Court Division -->
    <div class="flex flex-col">
      <label class="required-label">{{isSupremeCourtFlg?'Court':'Court Division'}}</label>
      <ng-container *ngIf="!isAddSearchFlag && isDivisionId===0; else readonlyDivision">
        <mat-form-field appearance="outline">
          <mat-select formControlName="courtDivision" [disabled]="isReadMode || isdivisionreadOnly"
            (selectionChange)="onCourtDivisionChange($event)">
            <mat-option *ngFor="let division of divisionList()" [value]="division">
              {{ division.courtUnitTypeName }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="searchForm.get('courtDivision')?.invalid">Field value required</mat-error>
        </mat-form-field>
      </ng-container>
      <ng-template #readonlyDivision>
        <mat-form-field appearance="outline">
          <input matInput readonly [disabled]="isReadMode"
            [value]="caseHandlerSearchData[0]?.courtUnitName ? caseHandlerSearchData[0].courtUnitName : courtUnitNameData">
        </mat-form-field>
      </ng-template>
    </div>

    <!-- Lower Court -->
    <div class="flex flex-col">
      <label class="required-label">{{isSupremeCourtFlg?'Appeal Division':'Lower Court'}}</label>
      <ng-container *ngIf="!isAddSearchFlag; else readonlyLowerCourt">
        <mat-form-field appearance="outline">
          <mat-select formControlName="lowerCourt" [disabled]="isReadMode" (selectionChange)="onLowerCourtSelect()">
            <mat-option *ngFor="let court of lowerCourts" [value]="court.id">
              {{ court.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="searchForm.get('lowerCourt')?.invalid">Field value required</mat-error>
        </mat-form-field>
      </ng-container>
      <ng-template #readonlyLowerCourt>
        <mat-form-field appearance="outline">
          <input matInput readonly [value]="caseHandlerSearchData[0]?.appealCourtName" [disabled]="isReadMode" />
          <mat-error *ngIf="searchForm.get('lowerCourt')?.invalid">Field value required</mat-error>
        </mat-form-field>
      </ng-template>
    </div>

    <!-- Appeal Type -->
    <div class="flex flex-col">
      <label class="required-label">Appeal Type</label>
      <ng-container *ngIf="!isAddSearchFlag; else readonlyAppealType">
        <mat-form-field appearance="outline">
          <mat-select formControlName="caseType" [disabled]="isReadMode" (selectionChange)="onCaseTypeChange($event)">
            <mat-option *ngFor="let type of caseTypeList()" [value]="type">
              {{ type.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="searchForm.get('caseType')?.invalid">Field value required</mat-error>
        </mat-form-field>
      </ng-container>
      <ng-template #readonlyAppealType>
        <mat-form-field appearance="outline">
          <input matInput readonly [value]="caseHandlerSearchData[0]?.ctpShortName" [disabled]="isReadMode" />
          <mat-error *ngIf="searchForm.get('caseType')?.invalid">Field value required</mat-error>
        </mat-form-field>
      </ng-template>
    </div>

    <!-- Document Types with Search -->
    <div class="flex flex-col">
      <label class="required-label">
        {{ isAddSearchFlag ? 'Document Types' :isSupremeCourtFlg?'Originating Process':'Case Initiating Document' }}
      </label>

      <!-- Loader shown while loading -->
      <ng-container *ngIf="isDocumentTypeLoading; else dropdownContent">
        <div class="flex items-center justify-center h-12">
          <mat-spinner diameter="24" strokeWidth="3"></mat-spinner>
        </div>
      </ng-container>

      <!-- Dropdown shown after loading completes -->
      <ng-template #dropdownContent>
        <mat-form-field appearance="outline">
          <mat-select formControlName="docTypeId" required [disabled]="isReadMode"
            [panelClass]="'custom-dropdown-panel'" (selectionChange)="onDocumentTypeChange($event)"
            (openedChange)="onDropdownOpened()">

            <!-- Search input inside dropdown -->
            <mat-option class="no-border-input search-option" disabled>
              <input #searchInput placeholder="Search Document Types" [value]="searchTerm"
                (input)="onSearchInput($event)" (keydown)="stopKeyEvent($event)" (click)="$event.stopPropagation()"
                class="dropdown-search" autocomplete="off" />
            </mat-option>

            <!-- Filtered document type list -->
            <mat-option *ngFor="let docType of filteredDocumentTypes" [value]="docType">
              {{ docType.docmentTypeName }}
            </mat-option>

            <!-- No results fallback -->
            <mat-option *ngIf="!isLoading && filteredDocumentTypes.length === 0" disabled>
              Not found
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-template>
    </div>

  </form>

  <!-- <div class="text-lg mb-5">Document Details</div> -->
  <!-- SEARCH FORM -->
  <form [formGroup]="searchForm" class="grid grid-cols-4 gap-4 bg-fieldset mb-4 px-4 py-2 rounded"
    (ngSubmit)="fetchDocumentTypes()" *ngIf="!isSupremeCourtFlg && !isCOAFlg">

    <!-- Case Category -->
    <div class="flex flex-col">
      <label class="required-label">Case Category</label>
      <ng-container *ngIf="!isAddSearchFlag; else readonlyCategory">
        <mat-form-field appearance="outline">
          <mat-select formControlName="caseCategory" required [disabled]="isReadMode"
            (selectionChange)="onCaseCategoryChange($event)">
            <mat-option *ngFor="let category of caseCategories" [value]="category.key">
              {{ category.value }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="searchForm.get('caseCategory')?.invalid">Field value required</mat-error>
        </mat-form-field>
      </ng-container>
      <ng-template #readonlyCategory>
        <mat-form-field appearance="outline">
          <input matInput readonly
            [value]="caseHandlerSearchData[0].caseCategory === 'FI' ? 'First Instance' : 'Appeal'">
        </mat-form-field>
      </ng-template>
    </div>

    <!-- Court Division -->
    <div class="flex flex-col">
      <label class="required-label">Court Division</label>
      <ng-container *ngIf="!isAddSearchFlag && isDivisionId===0; else readonlyDivision">
        <mat-form-field appearance="outline">
          <mat-select formControlName="courtDivision" [disabled]="isReadMode"
            (selectionChange)="onCourtDivisionChange($event)">
            <mat-option *ngFor="let division of divisionList()" [value]="division">
              {{ division.courtUnitTypeName }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="searchForm.get('courtDivision')?.invalid">Field value required</mat-error>
        </mat-form-field>
      </ng-container>
      <ng-template #readonlyDivision>
        <mat-form-field appearance="outline">
          <input matInput readonly [disabled]="isReadMode"
            [value]="caseHandlerSearchData[0]?.courtUnitName ? caseHandlerSearchData[0].courtUnitName : courtUnitNameData">
        </mat-form-field>
      </ng-template>
    </div>

    <!-- Case Type -->
    <div class="flex flex-col">
      <label class="required-label">{{ caseTypeLabel }}</label>
      <ng-container *ngIf="isCaseTypeLoading; else caseTypeDropdown">
        <div class="flex items-center justify-center h-14">
          <mat-spinner diameter="24" strokeWidth="3"></mat-spinner>
        </div>
      </ng-container>
      <ng-template #caseTypeDropdown>
        <ng-container *ngIf="!isAddSearchFlag; else readonlyCaseType">
          <mat-form-field appearance="outline">
            <mat-select formControlName="caseType" [disabled]="isReadMode" (selectionChange)="onCaseTypeChange($event)">
              <mat-option *ngFor="let type of caseTypeList()" [value]="type">
                {{ type.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="searchForm.get('caseType')?.invalid">Field value required</mat-error>
          </mat-form-field>
        </ng-container>
        <ng-template #readonlyCaseType>
          <mat-form-field appearance="outline">
            <input matInput readonly [value]="caseHandlerSearchData[0].ctpShortName">
          </mat-form-field>
        </ng-template>
      </ng-template>
    </div>

    <!-- Document Type with Search -->
    <div class="flex flex-col">
      <label class="required-label">{{ isAddSearchFlag ? 'Document Types' : 'Case Initiating Document' }}</label>

      <!-- Loader shown while loading -->
      <ng-container *ngIf="isDocumentTypeLoading; else documentTypeDropdown">
        <div class="flex items-center justify-center h-14">
          <mat-spinner diameter="24" strokeWidth="3"></mat-spinner>
        </div>
      </ng-container>

      <!-- Dropdown shown after loading -->
      <ng-template #documentTypeDropdown>
        <mat-form-field appearance="outline">
          <mat-select formControlName="docTypeId" required [disabled]="isReadMode"
            [panelClass]="'custom-dropdown-panel'" (selectionChange)="onDocumentTypeChange($event)"
            (openedChange)="onDropdownOpened()">

            <!-- Search box inside dropdown -->
            <mat-option class="no-border-input search-option" disabled>
              <input #searchInput placeholder="Search Document Types" [value]="searchTerm"
                (input)="onSearchInput($event)" (keydown)="stopKeyEvent($event)" class="dropdown-search"
                autocomplete="off" />
            </mat-option>

            <!-- Document type options -->
            <mat-option *ngFor="let docType of filteredDocumentTypes" [value]="docType">
              {{ docType.docmentTypeName }}
            </mat-option>

            <!-- No options -->
            <mat-option *ngIf="!isLoading && filteredDocumentTypes.length === 0" disabled>
              Not found
            </mat-option>
          </mat-select>

          <mat-error *ngIf="searchForm.get('docTypeId')?.invalid">
            Field value required
          </mat-error>
        </mat-form-field>
      </ng-template>
    </div>

  </form>


  <!-- Show loader when loading -->
  <div *ngIf="isCheckLoading" style="padding: 16px; text-align: center;">
    <mat-spinner diameter="30"></mat-spinner>
  </div>

  <!-- Show table when not loading and showCaseStage is false -->
  <div style="border: 1px solid #b0b0b0; width: 100%; font-family: Arial, sans-serif;"
    *ngIf="!isCheckLoading && !showCaseStage && !isAddSearchFlag &&!(isSupremeCourtFlg || isCOAFlg)">
    <div style="background-color: var(--ncms-primary); color: white; padding: 8px; font-weight: bold;">
      Mandatory Documents List
    </div>

    <div style="height: 300px; overflow-y: auto;">
      <!-- Loader shown while isCheckLoading is true -->
      <ng-container *ngIf="isCheckLoading; else documentTable">
        <div style="height: 300px; display: flex; align-items: center; justify-content: center;">
          <mat-spinner diameter="30" strokeWidth="4"></mat-spinner>
        </div>
      </ng-container>

      <!-- Actual table shown when not loading -->
      <ng-template #documentTable>
        <table style="width: 100%; border-collapse: collapse; table-layout: fixed;">
          <thead>
            <tr style="background-color: var(--ncms-table-header-bg);">
              <th style="padding-left: 8px; border: 1px solid #fffefe; width: 5%; text-align: left;"></th>
              <th style="padding-left: 8px; border: 1px solid #fffefe; width: 50%; text-align: left;">Document Name</th>
              <th style="padding-left: 8px; border: 1px solid #fffefe; width: 45%; text-align: left;">Mandatory/Optional
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let doc of mandatoryDocuments; let i = index"
              [style.background-color]="i % 2 === 0 ? '#ffffff' : '#eaf2fb'">
              <td style="padding: 4px; border: 1px solid #e0e0e0; text-align: left;">{{ i + 1 }}</td>
              <td
                style="padding: 4px; border: 1px solid #e0e0e0; text-align: left; white-space: normal; word-wrap: break-word;">
                {{ doc.documentTypeName }}
              </td>
              <td style="padding: 4px; border: 1px solid #e0e0e0; text-align: left;">
                {{ doc.mandatory === 'Y' ? 'Mandatory' : 'Optional' }}
              </td>
            </tr>
          </tbody>
        </table>
      </ng-template>
    </div>

  </div>





  <div *ngIf="!(isSupremeCourtFlg || isCOAFlg)">
    <!-- Confirmation Checkbox -->
    <div class="col-span-4" *ngIf="!isAddSearchFlag&&!showCaseStage">
      <mat-checkbox [(ngModel)]="confirmDocuments" class="w-full"
        [disabled]="searchForm.invalid || isLoading || isReadMode">
        <span>
          I confirm that the above listed mandatory documents are available and valid for Case/Appeal creation
        </span>
      </mat-checkbox>
    </div>

    <!-- Action Buttons -->
    <!-- <div  class="col-span-4 flex justify-center gap-4 mt-4">
      <button *ngIf="!showCaseStage" type="button" mat-flat-button class="cancel-button" (click)="close()"> Cancel </button>
      <button *ngIf="!showCaseStage" type="submit" mat-flat-button color="primary" [disabled]="!confirmDocuments || isLoading" (click)="onNext()">
          {{ isLoading ? 'Loading...' : 'Next' }}
      </button>
  </div> -->
    <div *ngIf="!isAddSearchFlag" class="col-span-4 flex justify-center gap-4 mt-4">
      <button *ngIf="!showCaseStage" type="button" mat-flat-button class="cancel-button" (click)="close()"> Cancel
      </button>
      <button *ngIf="!showCaseStage" type="submit" mat-flat-button color="primary"
        [disabled]="!confirmDocuments || isLoading" (click)="onNext()">
        {{ isLoading ? 'Loading...' : 'Next' }}
      </button>
    </div>
  </div>
  <div [@slideInOut]="!isNextClicked ? 'in' : 'out'" *ngIf="!isNextClicked">
    <form *ngIf="showCaseStage||isAddSearchFlag||isSupremeCourtFlg||isCOAFlg" [formGroup]="searchForm2"
      class="px-4 btn-icon-section bg-fieldset" (ngSubmit)="onSaveSubmit()">
      <div class="flex">
        <div>
          <div *ngIf="!(isSupremeCourtFlg||isCOAFlg)" class="flex flex-wrap">
            <div class="col-7" *ngIf="selectedCategory !== 'FI'">
              <label class="required-label">{{isSupremeCourtFlg?'Court Below':'Lower Court'}}</label>
              <div class="flex">
                <mat-form-field>
                  <mat-select formControlName="lowerCourt" (selectionChange)="onLowerCourtSelect()"
                    *ngIf="!isAddSearchFlag">
                    <mat-option *ngFor="let court of lowerCourts" [value]="court.id">
                      {{ court.name }}
                    </mat-option>
                  </mat-select>
                  <input matInput readonly [value]="caseHandlerSearchData[0].appealCourtName " [disabled]="isReadMode"
                    *ngIf="isAddSearchFlag">
                  <mat-error *ngIf="searchForm.get('lowerCourt')?.invalid">Field value required</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div *ngIf="isSupremeCourtFlg||isCOAFlg" class="col-7">
              <label class="required-label">{{ selectedCategory !== 'FI' ? 'Appeal Stage' : 'Case Stage' }}</label>
              <div class="flex">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-select formControlName="caseStageId" [disabled]="isReadMode">
                    <mat-option *ngFor="let caseStage of caseStages" [value]="caseStage.documentTypeCasePhaseTypeId">
                      {{ caseStage.phaseName }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="searchForm.get('caseStageId')?.invalid">Field value required</mat-error>
                </mat-form-field>
              </div>
            </div>

            <!-- <div class="col-3"*ngIf="selectedCategory !== 'FI'">
      <label class="required-label">*{{'Appeal Stage'}}</label>
      <div class="flex">
      <mat-form-field appearance="outline" class="full-width">
        <mat-select formControlName="caseStageId" [disabled]="isReadMode">>
          <mat-option *ngFor="let caseStage of caseStages" [value]="caseStage.documentTypeCasePhaseTypeId">
            {{ caseStage.phaseName }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="searchForm.get('caseStageId')?.invalid">Field value required</mat-error>
      </mat-form-field>
      </div>
    </div> -->

            <div class="col-1" *ngIf="selectedCategory !== 'FI'"></div>
            <div *ngIf="!(isSupremeCourtFlg||isCOAFlg||selectedCategory === 'FI')" class="col-4">
              <label class="required-label">{{ selectedCategory !== 'FI' ? 'Appeal Stage' : 'Case Stage' }}</label>
              <div class="flex">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-select formControlName="caseStageId" [disabled]="isReadMode">
                    <mat-option *ngFor="let caseStage of caseStages" [value]="caseStage.documentTypeCasePhaseTypeId">
                      {{ caseStage.phaseName }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="searchForm.get('caseStageId')?.invalid">Field value required</mat-error>
                </mat-form-field>
              </div>
            </div>

          </div>
          <div *ngIf="(isSupremeCourtFlg||isCOAFlg) && !isAddSearchFlag" class="flex flex-wrap pt-5">
            <div *ngIf="(!isCOAFlg) && selectedCategory !== 'FI'" class="col-4">
              <div class="w-full" *ngIf="searchForm2.get('backlogCase')?.value">
                <label class="required-label d-block mb-1">Supreme Court Case Number:</label>
                <mat-form-field appearance="outline" class="full-width">
                  <input matInput appAlphaNumSlash formControlName="backlogCaseNumber"
                    placeholder="Enter Supreme Court Number" />
                  <mat-progress-spinner *ngIf="backlogCaseNumberCtrl?.pending" matSuffix diameter="18"
                    mode="indeterminate">
                  </mat-progress-spinner>

                  <mat-error *ngIf="backlogCaseNumberCtrl?.hasError('pattern')">
                    Only letters, numbers, and "/" are allowed.
                  </mat-error>

                  <mat-error *ngIf="backlogCaseNumberCtrl?.hasError('alreadyExists')">
                    Case number already exists.
                  </mat-error>
                  <mat-error *ngIf="backlogCaseNumberCtrl?.hasError('server')">
                    Could not verify right now. Please try again.
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div *ngIf="!isSupremeCourtFlg" class="flex flex-wrap">
            <div *ngIf="isCOAFlg" class="col-6">
              <label class="required-label">{{ selectedCategory !== 'FI' ? 'Appeal Stage' : 'Case Stage' }}</label>
              <div class="flex">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-select formControlName="caseStageId" [disabled]="isReadMode">
                    <mat-option *ngFor="let caseStage of caseStages" [value]="caseStage.documentTypeCasePhaseTypeId">
                      {{ caseStage.phaseName }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="searchForm.get('caseStageId')?.invalid">Field value required</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-2"></div>
            <div *ngIf="isCOAFlg" class="col-4">
              <label class="required-label">Filed on</label>
              <div class="flex">
                <mat-form-field appearance="outline" class="full-width">
                  <input matInput [matDatepicker]="picker" formControlName="filedOn" placeholder="Select date"
                    (dateChange)="onDateChange($event)" [max]="maxDate" />
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </div>
            </div>

          </div>
          <div *ngIf="(isSupremeCourtFlg||isCOAFlg)" class="flex flex-wrap">

            <div *ngIf="isSupremeCourtFlg" class="col-6">
              <label class="required-label">{{ selectedCategory !== 'FI' ? 'Appeal Stage' : 'Case Stage' }}</label>
              <div class="flex">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-select formControlName="caseStageId" [disabled]="isReadMode">
                    <mat-option *ngFor="let caseStage of caseStages" [value]="caseStage.documentTypeCasePhaseTypeId">
                      {{ caseStage.phaseName }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="searchForm.get('caseStageId')?.invalid">Field value required</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-2"></div>
            <div *ngIf="(isSupremeCourtFlg)&&selectedCategory !== 'FI'" class="col-4">
              <label class="required-label">Filed on</label>
              <div class="flex">
                <mat-form-field appearance="outline" class="full-width">
                  <input matInput [matDatepicker]="picker" formControlName="filedOn" placeholder="Select date"
                    (dateChange)="onDateChange($event)" [max]="maxDate" />
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </div>
            </div>

          </div>
          <!-- <div class="flex flex-wrap">
    <!-- <div class="col-3">
      <label class="required-label">*{{'Case Stage'}}</label>
      <div class="flex">
      <mat-form-field appearance="outline" class="full-width" >
        <mat-select formControlName="caseStageId" [disabled]="isReadMode" >
          <mat-option *ngFor="let caseStage of caseStages" [value]="caseStage.documentTypeCasePhaseTypeId" >
            {{ caseStage.phaseName }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="searchForm.get('caseStageId')?.invalid">Field value required</mat-error>
      </mat-form-field>
      </div>
    </div> -->


          <!-- <div *ngIf="isSupremeCourtFlg||isCOAFlg" class="col-3">
      <label class="required-label">Appeal Stages</label>
      <mat-form-field appearance="outline" class="full-width">
        <mat-select formControlName="caseStageId">
          <mat-option *ngFor="let caseStage of caseStages" [value]="caseStage.documentTypeCasePhaseTypeId" >
            {{ caseStage.phaseName }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="searchForm.get('caseStageId')?.invalid">Field value required</mat-error>
      </mat-form-field>
    </div>


    <div class="col-3"></div> -->


          <div class="flex flex-wrap">
            <div class="col-7">
              <label class="required-label">{{ sessionConstant.FILED_BY_LABEL}}</label>
              <div class="flex">
                <mat-form-field appearance="outline" class="flex-grow mr-2">
                  <input matInput formControlName="petitionerSearchName" readonly />
                </mat-form-field>
                <mat-form-field appearance="outline" class="flex-grow">
                  <input matInput formControlName="partiesNameText" required placeholder="Party Name" />
                  <button mat-icon-button matSuffix (click)="onFiledBySearch()">
                    <mat-icon>search</mat-icon>
                  </button>
                </mat-form-field>
                <button mat-icon-button color="primary" class="ml-1" (click)="showAddParty('filedBy')">
                  <mat-icon>add</mat-icon>
                </button>
              </div>
            </div>
            <div class="col-1"></div>
            <div *ngIf="isSupremeCourtFlg" class="col-4">
              <label [ngClass]="{ 'required-label': !isAddSearchFlag }">{{ isSupremeCourtFlg ? 'Court of Appeal Number'
                : 'Old Appeal Number' }}</label>
              <mat-form-field appearance="outline" class="full-width">
                <input matInput formControlName="oldSuitNumber" required
                  [placeholder]="isAddSearchFlag ? '' : isSupremeCourtFlg ? 'Enter Court of Appeal Number': 'Enter Old Appeal Number'"
                  [disabled]="isAddSearchFlag" [readonly]="isAddSearchFlag"
                  [ngClass]="{ 'fade-readonly': isAddSearchFlag }" />
              </mat-form-field>
            </div>

            <div *ngIf="isAddSearchFlag && (isCOAFlg)" class="col-3">
              <label>Suit Number</label>
              <mat-form-field appearance="outline" class="full-width">
                <input matInput formControlName="suitNumberFormData"
                  [placeholder]="isAddSearchFlag ? '' : 'Enter Old Suit Number'" [disabled]="isAddSearchFlag"
                  [ngClass]="{ 'fade-readonly': isAddSearchFlag }" readonly />
              </mat-form-field>
            </div>
            <div *ngIf="!(isSupremeCourtFlg||isCOAFlg||selectedCategory !== 'FI')" class="col-4">
              <label class="required-label">{{ selectedCategory !== 'FI' ? 'Appeal Stage' : 'Case Stage' }}</label>
              <div class="flex">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-select formControlName="caseStageId" [disabled]="isReadMode">
                    <mat-option *ngFor="let caseStage of caseStages" [value]="caseStage.documentTypeCasePhaseTypeId">
                      {{ caseStage.phaseName }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="searchForm.get('caseStageId')?.invalid">Field value required</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div *ngIf="!isSupremeCourtFlg&&!isCOAFlg&&selectedCategory !== 'FI'" class="col-4">
              <label class="required-label">Filed on</label>
              <div class="flex">
                <mat-form-field appearance="outline" class="full-width">
                  <input matInput [matDatepicker]="picker" formControlName="filedOn" placeholder="Select date"
                    (dateChange)="onDateChange($event)" [max]="maxDate" />
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
            <div *ngIf="!isAddSearchFlag && isCOAFlg" class="col-4">
              <label [ngClass]="{ 'required-label': !isAddSearchFlag }">{{ isSupremeCourtFlg ? 'Trial Court Number' :
                'Suit Number' }}</label>
              <mat-form-field appearance="outline" class="full-width" [hideRequiredMarker]="false" floatLabel="always">
                <input matInput formControlName="suitNumberFormData"
                  [placeholder]="isAddSearchFlag ? '' : isSupremeCourtFlg ? 'Enter Trial Court Number' : 'Enter Suit Number'"
                  [disabled]="isAddSearchFlag" [ngClass]="{ 'fade-readonly': isAddSearchFlag }"
                  [required]="!isAddSearchFlag" />
              </mat-form-field>
            </div>
            <!-- <div class="col-3">
      <label class="required-label">*Filed on</label>
      <div class="flex">
      <mat-form-field appearance="outline" class="full-width">
        <input matInput [matDatepicker]="picker" formControlName="filedOn" placeholder="Select date" (dateChange)="onDateChange($event)"/>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
    </div> -->
            <!-- <div *ngIf="selectedCategory !== 'FI'" class="col-3">
      <mat-label>*Old Suit Number</mat-label>
      <mat-form-field appearance="outline" class="full-width">
        <input matInput formControlName="oldSuitNumber" placeholder="Enter Old Suit Number" required/>
      </mat-form-field>
    </div> -->
            <!-- Table Section -->
            <div class="w-full flex flex-col">
              <div *ngIf="showTableFor === 'filedBy'" class="table-container  w-full">
                <div *ngIf="isTableVisible" class="table-header">
                  <h2 class="table-title">Add Party</h2>
                  <div class="table-actions">
                    <button mat-flat-button class="cancel-button" (click)="closeTable()">Cancel</button>
                    <button mat-flat-button color="primary" [disabled]="!selectedRow" (click)="addSelectedRow()">
                      Add Party</button>
                  </div>
                </div>

                <div class="table-wrapper">
                  <mat-table *ngIf="isTableVisible" [dataSource]="parties" class="mat-elevation-z8"
                    style="width: 100%; table-layout: fixed;">
                    <!-- Columns -->
                    <ng-container matColumnDef="prtType">
                      <th mat-header-cell *matHeaderCellDef> Party Type </th>
                      <td mat-cell *matCellDef="let element"> {{ element.prtType }} </td>
                    </ng-container>

                    <ng-container matColumnDef="partiesId">
                      <th mat-header-cell *matHeaderCellDef> Party ID </th>
                      <td mat-cell *matCellDef="let element"> {{ element.partiesId }} </td>
                    </ng-container>

                    <ng-container matColumnDef="idStructureTypeName">
                      <th mat-header-cell *matHeaderCellDef> ID Name </th>
                      <td mat-cell *matCellDef="let element"> {{ element.idStructureTypeName }} </td>
                    </ng-container>

                    <ng-container matColumnDef="idStructureTypeValue">
                      <th mat-header-cell *matHeaderCellDef> ID Number </th>
                      <td mat-cell *matCellDef="let element"> {{ element.idStructureTypeValue }} </td>
                    </ng-container>

                    <ng-container matColumnDef="partiesFullName">
                      <th mat-header-cell *matHeaderCellDef> Full Name </th>
                      <td mat-cell *matCellDef="let element"> {{ element.partiesFullName }} </td>
                    </ng-container>

                    <!-- Select Column -->
                    <ng-container matColumnDef="select">
                      <th mat-header-cell *matHeaderCellDef> Select </th>
                      <td mat-cell *matCellDef="let element">
                        <mat-checkbox [checked]="selectedRow === element"
                          (change)="onRowSelected(element, $event.checked)">
                        </mat-checkbox>
                      </td>
                    </ng-container>

                    <!-- Header Row and Data Rows -->
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                  </mat-table>
                </div>
              </div>
            </div>
            <!--Select Party Start-->

            <div *ngIf="currentAddPartySection === 'filedBy' && showAddPartyForm"
              class="add-party-form-container col-12 mt-2 form-wrapper" [formGroup]="addPartyForm">
              <div class="header-section">
                <label class="party-type-label">Select Party Type</label>
                <div class="form-actions">
                  <button mat-flat-button class="cancel-button mr-2" (click)="cancelAddParty()">Cancel</button>
                  <button mat-flat-button color="primary" [disabled]="!addPartyForm.valid || isAddLoading"
                    (click)="!isAddLoading && submitAddParty()">
                    <ng-container *ngIf="!isAddLoading; else loadingSpinner">
                      Add
                    </ng-container>
                    <ng-template #loadingSpinner>
                      <mat-progress-spinner diameter="20" mode="indeterminate" color="accent" strokeWidth="3"
                        class="ml-2"></mat-progress-spinner>
                    </ng-template>
                  </button>

                </div>
              </div>
              <div class="party-type-section">
                <mat-radio-group formControlName="partyType" class="party-type-options d-flex flex-wrap">
                  <mat-radio-button value="GRP">Group</mat-radio-button>
                  <mat-radio-button value="PRS">Person</mat-radio-button>
                  <mat-radio-button value="CRE">Corporate</mat-radio-button>
                  <mat-radio-button value="GOVT">Govt</mat-radio-button>
                </mat-radio-group>
              </div>
              <div class="form-container">
                <div class="form-field" *ngIf="!isGroupSelected()">
                  <label class="required-label">Name</label>
                  <div class="flex">
                    <mat-form-field appearance="outline" class="full-width">
                      <input matInput formControlName="partyName" placeholder="Name" />
                    </mat-form-field>
                  </div>
                </div>

                <div class="form-field" *ngIf="isGroupSelected()">
                  <label class="required-label">Head Name</label>
                  <mat-form-field appearance="outline" class="full-width">
                    <input matInput formControlName="partyName" placeholder="Head Name" />
                  </mat-form-field>
                </div>

                <div class="form-field" *ngIf="isGroupSelected()">
                  <label class="required-label">Head Surname</label>
                  <mat-form-field appearance="outline" class="full-width">
                    <input matInput formControlName="partySurname" placeholder="Head Surname" />
                  </mat-form-field>
                </div>

                <div class="form-field" *ngIf="isGroupSelected()">
                  <label class="required-label">Group Name</label>
                  <mat-form-field appearance="outline" class="full-width">
                    <input matInput formControlName="partyGroupName" placeholder="Group Name" />
                  </mat-form-field>
                </div>

                <div class="form-field" *ngIf="isGroupSelected()">
                  <label class="required-label">Party Type</label>
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-select formControlName="partyTypeDropdown">
                      <mat-option *ngFor="let type of partyTypeDropdownList" [value]="type.value">
                        {{ type.key }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="form-field" *ngIf="isPersonSelected()">
                  <label class="required-label">Surname</label>
                  <mat-form-field appearance="outline" class="full-width">
                    <input matInput formControlName="partySurname" placeholder="Surname" />
                  </mat-form-field>
                </div>

                <div class="form-field">
                  <label class="required-label">ID Type</label>
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-select formControlName="idType">
                      <mat-option *ngFor="let type of idTypeList" [value]="type.id">
                        {{ type.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="form-field">
                  <label class="required-label">ID Number</label>
                  <mat-form-field appearance="outline" class="full-width">
                    <input matInput formControlName="idNumber" placeholder="ID Number" />
                  </mat-form-field>
                </div>

                <div class="form-field" *ngIf="isGroupSelected()">
                  <mat-label>Additional Info</mat-label>
                  <mat-form-field appearance="outline" class="full-width">
                    <input matInput formControlName="partyAdditionalInfo" placeholder="Additional Info" />
                  </mat-form-field>
                </div>
              </div>
            </div>
            <!--Select Party end-->
          </div>

          <!-- Row 3: Plaintiff(s)/Claimant(s) -->
          <div class="flex flex-wrap">
            <div class="col-7">
              <label class="required-label">{{ sessionConstant.FIRST_PARTY_LABEL}}</label>
              <div class="flex">
                <mat-form-field appearance="outline" class="flex-grow mr-2">
                  <input matInput formControlName="plaintiffSearchName" readonly />
                </mat-form-field>
                <mat-form-field appearance="outline" class="flex-grow">
                  <input matInput formControlName="partiesPlaintiffNameText" required placeholder="Party Name"
                    [readonly]="isAddSearchFlag" [disabled]="isAddSearchFlag" />
                  <button mat-icon-button matSuffix (click)="onPlaintiffSearch()" [disabled]="  isAddSearchFlag">
                    <mat-icon>search</mat-icon>
                  </button>
                </mat-form-field>
                <button mat-icon-button color="primary" class="ml-1" (click)="showAddParty('plaintiff')"
                  [disabled]="isAddSearchFlag">
                  <mat-icon>add</mat-icon>
                </button>
              </div>
            </div>
            <!-- <div *ngIf="selectedCategory !== 'FI'" class="col-1"></div>
    <div *ngIf="selectedCategory !== 'FI'" class="col-3">
      <label class="required-label">*Lower Court</label>
      <mat-form-field>
        <mat-select formControlName="lowerCourt" (selectionChange)="onLowerCourtSelect()">
            <mat-option *ngFor="let court of lowerCourts" [value]="court.id">
                {{ court.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    </div> -->
            <div class="col-1"></div>
            <div *ngIf="isSupremeCourtFlg" class="col-4">
              <label [ngClass]="{ 'required-label': !isAddSearchFlag }">{{ isSupremeCourtFlg ? 'Trial Court Number' :
                'Suit Number' }}</label>
              <mat-form-field appearance="outline" class="full-width" [hideRequiredMarker]="false" floatLabel="always">
                <input matInput formControlName="suitNumberFormData"
                  [placeholder]="isAddSearchFlag ? '' : isSupremeCourtFlg ? 'Enter Trial Court Number' : 'Enter Suit Number'"
                  [disabled]="isAddSearchFlag" [ngClass]="{ 'fade-readonly': isAddSearchFlag }"
                  [required]="!isAddSearchFlag" />
              </mat-form-field>
            </div>
            <div class="flex flex-wrap items-center mt-3">
            </div>
            <div *ngIf="(!isSupremeCourtFlg)&&selectedCategory !== 'FI'&&!isCOAFlg" class="col-4">
              <label class="required-label">Old Appeal Number</label>
              <mat-form-field appearance="outline" class="full-width">
                <input matInput formControlName="oldSuitNumber" required [disabled]="isAddSearchFlag"
                  [readonly]="isAddSearchFlag" [ngClass]="{ 'fade-readonly': isAddSearchFlag }" />
              </mat-form-field>
            </div>
            <div *ngIf="selectedCategory === 'FI'" class="col-4">
              <label class="required-label">Filed on</label>
              <div class="flex">
                <mat-form-field appearance="outline" class="full-width">
                  <input matInput [matDatepicker]="picker" formControlName="filedOn" placeholder="Select date"
                    (dateChange)="onDateChange($event)" [max]="maxDate" />
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </div>
            </div>

            <div class="w-full flex flex-col">
              <div *ngIf="showTableFor === 'plaintiff'" class="table-container  w-full">
                <div *ngIf="isTableVisible" class="table-header">
                  <h2 class="table-title">Add Party</h2>
                  <div class="table-actions">
                    <button mat-flat-button class="cancel-button mr-2" (click)="closeTable()">Cancel</button>
                    <button mat-flat-button color="primary" [disabled]="!selectedRow" (click)="addSelectedRow()">Add
                      Party</button>
                  </div>
                </div>

                <div class="table-wrapper">
                  <mat-table *ngIf="isTableVisible" [dataSource]="parties" class="mat-elevation-z8"
                    style="width: 100%; table-layout: fixed;">
                    <!-- Columns -->
                    <ng-container matColumnDef="prtType">
                      <th mat-header-cell *matHeaderCellDef> Party Type </th>
                      <td mat-cell *matCellDef="let element"> {{ element.prtType }} </td>
                    </ng-container>

                    <ng-container matColumnDef="partiesId">
                      <th mat-header-cell *matHeaderCellDef> Party ID </th>
                      <td mat-cell *matCellDef="let element"> {{ element.partiesId }} </td>
                    </ng-container>

                    <ng-container matColumnDef="idStructureTypeName">
                      <th mat-header-cell *matHeaderCellDef> ID Name </th>
                      <td mat-cell *matCellDef="let element"> {{ element.idStructureTypeName }} </td>
                    </ng-container>

                    <ng-container matColumnDef="idStructureTypeValue">
                      <th mat-header-cell *matHeaderCellDef> ID Number </th>
                      <td mat-cell *matCellDef="let element"> {{ element.idStructureTypeValue }} </td>
                    </ng-container>

                    <ng-container matColumnDef="partiesFullName">
                      <th mat-header-cell *matHeaderCellDef> Full Name </th>
                      <td mat-cell *matCellDef="let element"> {{ element.partiesFullName }} </td>
                    </ng-container>

                    <!-- Select Column -->
                    <ng-container matColumnDef="select">
                      <th mat-header-cell *matHeaderCellDef> Select </th>
                      <td mat-cell *matCellDef="let element">
                        <mat-checkbox [checked]="selectedRow === element"
                          (change)="onRowSelected(element, $event.checked)">
                        </mat-checkbox>
                      </td>
                    </ng-container>

                    <!-- Header Row and Data Rows -->
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                  </mat-table>
                </div>
              </div>
            </div>
            <!--Select Party Start-->
            <div *ngIf="currentAddPartySection === 'plaintiff' && showAddPartyForm"
              class="add-party-form-container col-12 mt-2 form-wrapper" [formGroup]="addPartyForm">
              <div class="header-section">
                <label class="party-type-label">Select Party Type</label>
                <div class="form-actions">
                  <button mat-flat-button class="cancel-button mr-2" (click)="cancelAddParty()">Cancel</button>
                  <button mat-flat-button color="primary" [disabled]="!addPartyForm.valid || isAddLoading"
                    (click)="!isAddLoading && submitAddParty()">
                    <ng-container *ngIf="!isAddLoading; else loadingSpinner">
                      Add
                    </ng-container>
                    <ng-template #loadingSpinner>
                      <mat-progress-spinner diameter="20" mode="indeterminate" color="accent" strokeWidth="3"
                        class="ml-2"></mat-progress-spinner>
                    </ng-template>
                  </button>

                </div>
              </div>
              <div class="party-type-section">
                <mat-radio-group formControlName="partyType" class="party-type-options d-flex flex-wrap">
                  <mat-radio-button value="GRP">Group</mat-radio-button>
                  <mat-radio-button value="PRS">Person</mat-radio-button>
                  <mat-radio-button value="CRE">Corporate</mat-radio-button>
                  <mat-radio-button value="GOVT">Govt</mat-radio-button>
                </mat-radio-group>
              </div>
              <div class="form-container">
                <div class="form-field" *ngIf="!isGroupSelected()">
                  <label class="required-label">Name</label>
                  <div class="flex">
                    <mat-form-field appearance="outline" class="full-width">
                      <input matInput formControlName="partyName" placeholder="Name" />
                    </mat-form-field>
                  </div>
                </div>

                <div class="form-field" *ngIf="isGroupSelected()">
                  <label class="required-label">Head Name</label>
                  <mat-form-field appearance="outline" class="full-width">
                    <input matInput formControlName="partyName" placeholder="Head Name" />
                  </mat-form-field>
                </div>

                <div class="form-field" *ngIf="isGroupSelected()">
                  <label class="required-label">Head Surname</label>
                  <mat-form-field appearance="outline" class="full-width">
                    <input matInput formControlName="partySurname" placeholder="Head Surname" />
                  </mat-form-field>
                </div>

                <div class="form-field" *ngIf="isGroupSelected()">
                  <label class="required-label">Group Name</label>
                  <mat-form-field appearance="outline" class="full-width">
                    <input matInput formControlName="partyGroupName" placeholder="Group Name" />
                  </mat-form-field>
                </div>

                <div class="form-field" *ngIf="isGroupSelected()">
                  <label class="required-label">Party Type</label>
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-select formControlName="partyTypeDropdown">
                      <mat-option *ngFor="let type of partyTypeDropdownList" [value]="type.value">
                        {{ type.key }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="form-field" *ngIf="isPersonSelected()">
                  <label class="required-label">Surname</label>
                  <mat-form-field appearance="outline" class="full-width">
                    <input matInput formControlName="partySurname" placeholder="Surname" />
                  </mat-form-field>
                </div>

                <div class="form-field">
                  <label class="required-label">ID Type</label>
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-select formControlName="idType">
                      <mat-option *ngFor="let type of idTypeList" [value]="type.id">
                        {{ type.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="form-field">
                  <label class="required-label">ID Number</label>
                  <mat-form-field appearance="outline" class="full-width">
                    <input matInput formControlName="idNumber" placeholder="ID Number" />
                  </mat-form-field>
                </div>

                <div class="form-field" *ngIf="isGroupSelected()">
                  <mat-label>Additional Info</mat-label>
                  <mat-form-field appearance="outline" class="full-width">
                    <input matInput formControlName="partyAdditionalInfo" placeholder="Additional Info" />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <!--Select Party end-->


          <!-- Row 4: Defendant(s) -->
          <div class="flex flex-wrap">
            <div class="col-7">
              <label class="required-label">{{ sessionConstant.SECOND_PARTY_LABEL }}</label>
              <div class="flex">
                <mat-form-field appearance="outline" class="flex-grow mr-2">
                  <input matInput formControlName="defendantSearchName" readonly />
                </mat-form-field>
                <mat-form-field appearance="outline" class="flex-grow">
                  <input matInput formControlName="partiesDefendantNameText" required placeholder="Party Name"
                    [readonly]="isAddSearchFlag" [disabled]="isAddSearchFlag" />
                  <button mat-icon-button matSuffix (click)="onDefendantSearch()" [disabled]="isAddSearchFlag">
                    <mat-icon>search</mat-icon>
                  </button>
                </mat-form-field>
                <button mat-icon-button color="primary" class="ml-1" (click)="showAddParty('defendant')"
                  [disabled]="isAddSearchFlag">
                  <mat-icon>add</mat-icon>
                </button>
              </div>
            </div>
            <div class="col-1"></div>
            <div *ngIf="isSupremeCourtFlg && !isAddSearchFlag" class="col-4">
              <div class="w-full">
                <!-- Row 1: Slide Toggle -->

              </div>
            </div>

            <!-- Show backlog case number if toggle is ON -->


            <!-- <div *ngIf="selectedCategory !== 'FI'" class="col-1"></div>
    <div *ngIf="selectedCategory !== 'FI'" class="col-3">
      <mat-label>*Old Suit Number</mat-label>
      <mat-form-field appearance="outline" class="full-width">
        <input matInput formControlName="oldSuitNumber" placeholder="Enter Old Suit Number" required/>
      </mat-form-field>
    </div> -->
            <div class="col-3"></div>
            <div class="w-full flex flex-col">
              <div *ngIf="showTableFor === 'defendant'" class="table-container  w-full">
                <div *ngIf="isTableVisible" class="table-header">
                  <h2 class="table-title">Add Party</h2>
                  <div class="table-actions">
                    <button mat-flat-button class="cancel-button" (click)="closeTable()">Cancel</button>
                    <button mat-flat-button color="primary" [disabled]="!selectedRow" (click)="addSelectedRow()">Add
                      Party</button>
                  </div>
                </div>

                <div class="table-wrapper">
                  <mat-table *ngIf="isTableVisible" [dataSource]="parties" class="mat-elevation-z8"
                    style="width: 100%; table-layout: fixed;">
                    <!-- Columns -->
                    <ng-container matColumnDef="prtType">
                      <th mat-header-cell *matHeaderCellDef> Party Type </th>
                      <td mat-cell *matCellDef="let element"> {{ element.prtType }} </td>
                    </ng-container>

                    <ng-container matColumnDef="partiesId">
                      <th mat-header-cell *matHeaderCellDef> Party ID </th>
                      <td mat-cell *matCellDef="let element"> {{ element.partiesId }} </td>
                    </ng-container>

                    <ng-container matColumnDef="idStructureTypeName">
                      <th mat-header-cell *matHeaderCellDef> ID Name </th>
                      <td mat-cell *matCellDef="let element"> {{ element.idStructureTypeName }} </td>
                    </ng-container>

                    <ng-container matColumnDef="idStructureTypeValue">
                      <th mat-header-cell *matHeaderCellDef> ID Number </th>
                      <td mat-cell *matCellDef="let element"> {{ element.idStructureTypeValue }} </td>
                    </ng-container>

                    <ng-container matColumnDef="partiesFullName">
                      <th mat-header-cell *matHeaderCellDef> Full Name </th>
                      <td mat-cell *matCellDef="let element"> {{ element.partiesFullName }} </td>
                    </ng-container>

                    <!-- Select Column -->
                    <ng-container matColumnDef="select">
                      <th mat-header-cell *matHeaderCellDef> Select </th>
                      <td mat-cell *matCellDef="let element">
                        <mat-checkbox [checked]="selectedRow === element"
                          (change)="onRowSelected(element, $event.checked)">
                        </mat-checkbox>
                      </td>
                    </ng-container>

                    <!-- Header Row and Data Rows -->
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                  </mat-table>
                </div>
              </div>
            </div>

            <!--Select Party Start-->
            <div *ngIf="currentAddPartySection === 'defendant' && showAddPartyForm"
              class="add-party-form-container form-wrapper" [formGroup]="addPartyForm">
              <div class="header-section d-flex justify-content-between align-items-center">
                <label class="party-type-label">Select Party Type</label>
                <div class="form-actions">
                  <button mat-flat-button class="cancel-button mr-2" (click)="cancelAddParty()">Cancel</button>
                  <button mat-flat-button color="primary" [disabled]="!addPartyForm.valid || isAddLoading"
                    (click)="!isAddLoading && submitAddParty()">
                    <ng-container *ngIf="!isAddLoading; else loadingSpinner">
                      Add
                    </ng-container>
                    <ng-template #loadingSpinner>
                      <mat-progress-spinner diameter="20" mode="indeterminate" color="accent" strokeWidth="3"
                        class="ml-2"></mat-progress-spinner>
                    </ng-template>
                  </button>

                </div>
              </div>
              <div class="party-type-section">
                <mat-radio-group formControlName="partyType" class="party-type-options d-flex flex-wrap">
                  <mat-radio-button value="GRP">Group</mat-radio-button>
                  <mat-radio-button value="PRS">Person</mat-radio-button>
                  <mat-radio-button value="CRE">Corporate</mat-radio-button>
                  <mat-radio-button value="GOVT">Govt</mat-radio-button>
                </mat-radio-group>
              </div>
              <div class="form-container">
                <div class="form-field" *ngIf="!isGroupSelected()">
                  <label class="required-label">Name</label>
                  <div class="flex">
                    <mat-form-field appearance="outline" class="full-width">
                      <input matInput formControlName="partyName" placeholder="Name" />
                    </mat-form-field>
                  </div>
                </div>

                <div class="form-field" *ngIf="isGroupSelected()">
                  <label class="required-label">Head Name</label>
                  <mat-form-field appearance="outline" class="full-width">
                    <input matInput formControlName="partyName" placeholder="Head Name" />
                  </mat-form-field>
                </div>

                <div class="form-field" *ngIf="isGroupSelected()">
                  <label class="required-label">Head Surname</label>
                  <mat-form-field appearance="outline" class="full-width">
                    <input matInput formControlName="partySurname" placeholder="Head Surname" />
                  </mat-form-field>
                </div>

                <div class="form-field" *ngIf="isGroupSelected()">
                  <label class="required-label">Group Name</label>
                  <mat-form-field appearance="outline" class="full-width">
                    <input matInput formControlName="partyGroupName" placeholder="Group Name" />
                  </mat-form-field>
                </div>

                <div class="form-field" *ngIf="isGroupSelected()">
                  <label class="required-label">Party Type</label>
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-select formControlName="partyTypeDropdown">
                      <mat-option *ngFor="let type of partyTypeDropdownList" [value]="type.value">
                        {{ type.key }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="form-field" *ngIf="isPersonSelected()">
                  <label class="required-label">Surname</label>
                  <mat-form-field appearance="outline" class="full-width">
                    <input matInput formControlName="partySurname" placeholder="Surname" />
                  </mat-form-field>
                </div>

                <div class="form-field">
                  <label class="required-label">ID Type</label>
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-select formControlName="idType">
                      <mat-option *ngFor="let type of idTypeList" [value]="type.id">
                        {{ type.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="form-field">
                  <label class="required-label">ID Number</label>
                  <mat-form-field appearance="outline" class="full-width">
                    <input matInput formControlName="idNumber" placeholder="ID Number" />
                  </mat-form-field>
                </div>

                <div class="form-field" *ngIf="isGroupSelected()">
                  <mat-label>Additional Info</mat-label>
                  <mat-form-field appearance="outline" class="full-width">
                    <input matInput formControlName="partyAdditionalInfo" placeholder="Additional Info" />
                  </mat-form-field>
                </div>
              </div>
            </div>

            <!--Select Party end-->
          </div>

          <!-- Row 5: Comments -->
          <div class="col-span-12">
            <mat-label>Comments</mat-label>

            <mat-form-field appearance="outline" class="full-width">
              <textarea matInput formControlName="comments" placeholder="Enter comments" rows="3" cols="100"
                (input)="updateWordCount()" style="resize: vertical; min-height: 50px;">
      </textarea>

              <!-- live counter -->
              <mat-hint align="end">{{ wordCount }} / 3500 words</mat-hint>

              <!-- error when >150 -->
              <mat-error *ngIf="searchForm2.get('comments')?.hasError('maxWords')">
                Max 150 words allowed (you typed {{ searchForm2.get('comments')?.getError('maxWords')?.actual }}).
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <!-- <div class="col-4 px-2">
    <div class="form-container-sub">
      <h3>Auto Generated</h3>
      <div class="form-group">
        <label for="caseNumber">{{ selectedCategory==='FI'||isSupremeCourtFlg||isCOAFlg? 'Appeal Number:' : 'Case Number:' }}</label>
        <input id="caseNumber" type="text" class="form-control" [value]="caseHandlerSearchData[0]?.courtCaseNumber||''" readonly [tabindex]="null" [disabled]="true"/>
      </div>
      <div class="form-group">
        <label for="casePhaseId">{{selectedCategory==='FI'||isSupremeCourtFlg||isCOAFlg? 'Appeal Phase ID:' : 'Case Phase ID:' }}</label>
        <input id="casePhaseId" type="text" class="form-control" [value]="caseHandlerSearchData[0]?.casePhaseId||''" readonly [tabindex]="null"  [disabled]="true"/>
      </div>
      <div class="form-group">
        <label for="documentId">Document ID:</label>
        <input id="documentId" type="text" class="form-control" [value]="caseHandlerSearchData[0]?.docId||''" readonly [tabindex]="null" [disabled]="true" />
      </div>
      <div class="form-group">
        <label for="caseId">{{ selectedCategory==='FI'||isSupremeCourtFlg||isCOAFlg? 'Appeal ID:' : 'Case ID:' }}    </label>
        <input id="caseId" type="text" class="form-control" [value]="caseHandlerSearchData[0]?.casePhaseCasId||''" readonly [tabindex]="null" [disabled]="true" />
      </div></div></div></div> -->
      </div>
      <!-- Row 6: Action Buttons -->

    </form>
  </div>

  <mat-accordion *ngIf="isAddSearchFlag&&isSupremeCourtFlg" class="w-full px-2">
    <mat-expansion-panel [ngStyle]="{'background-color': '#f5f9f7'}">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Appeal Additional Details
        </mat-panel-title>
      </mat-expansion-panel-header>

      <app-court-form [courtOfAppealForm]="courtOfAppealForm" [trialCourtForm]="trialCourtForm" [isAddReadonly]="true"
        [initialData]="{
      lowerDivision: lowerCourtDisplayName,
      lowerCourtCaseNo: searchForm2.get('oldSuitNumber')?.value
    }"></app-court-form>

    </mat-expansion-panel>
  </mat-accordion>
  <div [@slideInOut]="isNextClicked ? 'in' : 'out'" *ngIf="isNextClicked"
    class="flex flex-col gap-0 bg-fieldset px-2 py-0 rounded">
    <app-court-form [courtOfAppealForm]="courtOfAppealForm" [trialCourtForm]="trialCourtForm"
      [isAddReadonly]="isAddSearchFlag" [initialData]="{
      lowerDivision: lowerCourtDisplayName,
      lowerCourtCaseNo: searchForm2.get('oldSuitNumber')?.value
    }"></app-court-form>


    <!-- Error template -->
    <ng-template #errorTemplate let-formField="formField" let-formGroup="formGroup">
      <div
        *ngIf="formGroup.get(formField)?.invalid && (formGroup.get(formField)?.dirty || formGroup.get(formField)?.touched)">
        <small class="text-red-500">Field value required</small>
      </div>
    </ng-template>
  </div>

  <div class="flex flex-wrap pt-6 justify-content-between"
    *ngIf="showCaseStage || isAddSearchFlag || isSupremeCourtFlg || isCOAFlg">

    <div class="col-12 text-center">
      <div class="btn-row">
        <button type="button" mat-flat-button class="cancel-button" (click)="close()">Cancel</button>

        <button *ngIf="isSupremeCourtFlg && !isNextClicked && !isAddSearchFlag" type="button" [disabled]="!canProceed"
          mat-flat-button color="primary" (click)="onNextClick()">
          Add Additional Details
        </button>

        <button *ngIf="!isSupremeCourtFlg && !isNextClicked" type="submit" mat-flat-button color="primary"
          [disabled]="!canSave" (click)="onSave()">
          Save
        </button>

        <button *ngIf="isSupremeCourtFlg && isNextClicked" type="button" mat-flat-button (click)="onPreviousClick()">
          Previous
        </button>

        <button *ngIf="isSupremeCourtFlg" type="submit" mat-flat-button color="primary" [disabled]="!canSave"
          (click)="onSave()">
          Save
        </button>
      </div>
    </div>
  </div>
</div>